import { c as _c } from "react/compiler-runtime";
import ResourcesBase from 'modules/digital-product/resources/components/resources-base';
import ResourcesSelect from 'modules/digital-product/resources/components/resources-select';
import { useDigitalResourceContent } from 'modules/digital-product/resources/hooks/use-digital-resource-content';
import { DigitalResourceEditType } from 'modules/digital-product/resources/types/digital-resource-edit-interface';
import { DigitalResourceType } from 'modules/digital-product/resources/types/digital-resource-interface';
import { DigitalProductChangeInterface, DigitalProductErrorInterface } from 'modules/digital-product/types/digital-product-interface';
import { AddItemIcon } from 'modules/funnels/funnel/components/offer-settings/add-item-icon';
import React from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
type Props = {
  resources: DigitalResourceEditType[];
  onChangeResources: (resources: DigitalProductChangeInterface['resources']) => void;
  errors: DigitalProductErrorInterface['resources'];
  disabled?: boolean;
};
const isResourceExists = (resource: DigitalResourceEditType | DigitalResourceType): resource is DigitalResourceType => !!resource.id;
function Resources(t0) {
  const $ = _c(29);
  const {
    resources,
    onChangeResources,
    errors,
    disabled
  } = t0;
  const {
    t
  } = useLocoTranslation();
  let t1;
  if ($[0] !== resources) {
    t1 = resources.filter(isResourceExists);
    $[0] = resources;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const existingResources = t1;
  let t2;
  if ($[2] !== resources) {
    t2 = resources.filter(_temp);
    $[2] = resources;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const newResources = t2;
  let t3;
  if ($[4] !== onChangeResources || $[5] !== resources) {
    t3 = id => onChangeResources(resources.filter(r_0 => r_0.id !== id));
    $[4] = onChangeResources;
    $[5] = resources;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const onDeleteExisting = t3;
  const existingResourcesData = useDigitalResourceContent(existingResources, onDeleteExisting);
  let t4;
  if ($[7] !== onChangeResources || $[8] !== resources) {
    t4 = () => onChangeResources([...resources, {
      type: undefined
    }]);
    $[7] = onChangeResources;
    $[8] = resources;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t) {
    t5 = t("dashboard.funnel.configuration.offer.add_digital_resource");
    $[10] = t;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== disabled || $[13] !== t4 || $[14] !== t5) {
    t6 = <AddItemIcon disabled={disabled} onClick={t4} caption={t5} />;
    $[12] = disabled;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== existingResources || $[17] !== onChangeResources) {
    t7 = newResources_0 => onChangeResources([...existingResources, ...newResources_0]);
    $[16] = existingResources;
    $[17] = onChangeResources;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== errors || $[20] !== existingResources.length || $[21] !== newResources || $[22] !== t7) {
    t8 = <ResourcesSelect errors={errors} resources={newResources} onChangeResources={t7} numberOfExistingResources={existingResources.length} />;
    $[19] = errors;
    $[20] = existingResources.length;
    $[21] = newResources;
    $[22] = t7;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  let t9;
  if ($[24] !== disabled || $[25] !== existingResourcesData || $[26] !== t6 || $[27] !== t8) {
    t9 = <ResourcesBase disabled={disabled} additionalChild={t6}>{t8}{existingResourcesData}</ResourcesBase>;
    $[24] = disabled;
    $[25] = existingResourcesData;
    $[26] = t6;
    $[27] = t8;
    $[28] = t9;
  } else {
    t9 = $[28];
  }
  return t9;
}
function _temp(r) {
  return !isResourceExists(r);
}
export default Resources;